// Components==============
import ArrowButton from 'components/UI/ArrowButton';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import RichText from '../RichText';
import './index.module.scss';
// =========================

export default function HeroLayout() {
    const { pathname } = useLocation();
    const routeSlug = pathname.split('/')[1];

    const page = useSelector((state) => {
        const pages = state.page.entities.allIds.map(
            (pageId) => state.page.entities.byId[pageId]
        );
        return pages.find((p) => p.slug === routeSlug);
    });

    const image = page?.image;
    const richText = page?.content;
    const buttons = page?.buttons?.map((b) => b.attributes);

    return !page ? (
        <>
            <div styleName="hero">
                <div
                    styleName={`${image ? 'image' : ''} header`}
                    style={{
                        background: image && `url(${image})`,
                    }}
                >
                    <div styleName="overlay" />
                    <h1>Helaas, die pagina is niet gevonden</h1>
                </div>
            </div>
        </>
    ) : (
        <>
            <div styleName="hero">
                <div
                    styleName="bottom"
                    style={{ gridTemplateColumns: !buttons?.length && '1fr' }}
                >
                    <div
                        styleName={`text ${
                            page.name === 'Verhalen' ||
                            page.slug === 'routekaart'
                                ? 'stories'
                                : ''
                        }`}
                    >
                        <RichText page slug={page?.slug} richText={richText} />
                    </div>
                    {buttons?.length ? (
                        <div styleName="buttons-wrapper">
                            <div styleName="buttons">
                                {buttons?.map((e) => (
                                    <ArrowButton
                                        // popup={e?.popup}
                                        // popupAccent={e?.popup_accent}
                                        key={e?.text}
                                        text={e?.text}
                                        subtitle={e?.subtitle}
                                        to={e?.link}
                                        type={e?.type}
                                        file={e?.file}
                                    />
                                ))}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        </>
    );
}
